<template>
  <div>
      <div class="header">
        <div class="container clearfix">
            <a href="http://www.bjrs.org.cn/" class="logo">
                <img :src="`${global.remoteIp}/uploads/${webConfigs.logopic}`" />
            </a>
            <div class="right">
                <div class="topxx">
                  <span class="week">{{time}}</span>
                  <div  class="shux"></div>
                  <router-link :to="aboutour" class="linkkj">关于我们</router-link>
                  <div  class="shux"></div>
                  <router-link :to="contactour" class="linkkj">联系我们</router-link>
                </div>
                <div class="search">
                    <div>
                        <div class="input">
                            <!-- <i class="el-icon-search"></i> -->
                            <input type="text" id="key" name="key" v-model="keyWords" placeholder="输入内容">
                            <div style="    width: 1px;
    height: 36px;
    background: rgb(224, 224, 224);
    display: inline-block;
    line-height: 36px;;"></div>
                            <input type="submit" class="submitBtn" @click="search()" value="搜索">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="nav">
        <div class="container">
            <ul class="clearfix">
                <li class="firstItem"><router-link to="/">首页</router-link></li>
                <li class="firstItem" v-for="(navmodel, index) in navs" :key="index">
                    <router-link
                        v-if="navmodel.type!=='link'"
                        :to="navmodel.link"
                        >{{ navmodel.name }}</router-link
                      >
                      <a v-else :href="navmodel.link" target="_blank">{{ navmodel.name }}</a>
                    <div class="navSub" v-if="navmodel.type =='hasSub'">
                        <ul>
                            <li v-for="(navsub, indexex) in navmodel.navSubs" :key="indexex"><router-link :to="navsub.link">{{navsub.name}}</router-link></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  name: "head-nav",
  props: {
    webConfigs: Object,
    plates: Array,
  },
  data() {
    return {
      global,
      keyWords: "",
      contactour: "",
      aboutour: "",
      articles: [],
      navs: [],
      time: "",
      timer:{}
    };
  },
  mounted() {
    this.timer = setInterval(this.getData, 1000);
    let navModels = [
      {
        name: "机构概况",
        type: "info",
      },
      {
        name: "课题研究",
        type: "view",
      },
      {
        name: "行业交流",
        type: "view",
      },
      {
        name: "培训信息",
        type:"view"
      },
      {
        name: "学术会议",
        type:"view"
      },
      {
        name: "信息查询",
        type: "local",
        link: "/inqCert"
      },
      {
        name: "研考课堂",
        type: "link",
        link: "http://www.cnks.org.cn"
      }
    ];
    // this.$axios.get("/api/categorys?page=1&limit=30").then((res) => {
    //   if (res.data) {
    let plates = this.plates;
    plates.forEach((plate) => {
      
      if (plate.name == "机构概况") {
        this.aboutour = "/news/info/" + plate._id + "/000000";
      } else if (plate.name == "联系我们") {
        this.contactour = "/news/info/" + plate._id + "/000000";
      }
    });

    navModels.forEach((model) => {
      let nav;
      if (model.type == "query") {
        nav = {
          name: model.name,
          link: "/applySociety",
        };
      } else if (model.type == "home") {
        nav = {
          name: model.name,
          link: "/",
        };
      }else if (model.type == "link"){
        nav = {
          name: model.name,
          link: model.link,
          type:'link'
        };
      }else if (model.type == "local"){
        nav = {
          name: model.name,
          link: model.link,
        };
      }else if (model.type == "hasSub")
      {
        let subs = model.navSub;
        nav = {
          navSubs:[]
        }
        for(let k = 0; k < subs.length; k++)
        {
          if(subs[k].type =='view')
          {
            for (let i = 0; i < plates.length; i++) {
              let plate = plates[i];
              if (subs[k].type == "info" && subs[k].name == plate.name) {
                nav.navSubs.push({
                  name: subs[k].name,
                  link: "/news/info/" + plate._id + "/000000",
                });
              } else if (subs[k].type == "view" && subs[k].name == plate.name) {
                nav.navSubs.push({
                  name: subs[k].name,
                  link: "/news/views/" + plate._id,
                });
              }else{
               
              }
            }
          }else{
            nav.navSubs.push({
              name: subs[k].name,
              link: subs[k].link,
            });
          }
        }
        nav.name = model.name;
        nav.type ='hasSub';
        console.log(nav.navSubs)
        nav.link = nav.navSubs[0]?nav.navSubs[0].link:'';
      }
      else {
        for (let i = 0; i < plates.length; i++) {
          let plate = plates[i];
          if (model.type == "info" && model.name == plate.name) {
            nav = {
              name: model.name,
              link: "/news/info/" + plate._id + "/000000",
            };
          } else if (model.type == "view" && model.name == plate.name) {
            nav = {
              name: model.name,
              link: "/news/views/" + plate._id,
            };
          }
        }
      }
      if (nav) this.navs.push(nav);
    });
     
  },
  created(){
    
  },
  methods: {
    getData() {
      
      let week = ["日", "一", "二", "三", "四", "五", "六"];
      let date = new Date();
      let getday = date.getDay();
      this.time= `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日 ${('00'+date.getHours()).slice(-2)}:${('00'+date.getMinutes()).slice(-2)}:${('00'+date.getSeconds()).slice(-2)} 星期${week[getday]}`;
    },
    search() {
      this.$router.replace("/news/views/search?keyWords=" + this.keyWords);
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style scoped>
.shux{
    width: 1px;
    height: 11px;
    background: #BEBFBF;
    display: inline-block;
    margin:0 18px;
}
.week{
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #8C8C8C;
}
.linkkj{
height: 14px;
font-size: 14px;
font-weight: 500;
color: #306BCD;
}
</style>
